module.exports = __webpack_public_path__ + "static/media/login-bg.be380bfe.jpg";